module.exports = __webpack_public_path__ + "static/img/tc01.4338f8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/tc01.png
// module id = 170
// module chunks = 0